import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const portSchema: CollectionCreateSchema = {
  name: CollectionName.Port,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    { name: "country_id", type: "int64", sort: true, infix: true },
    {
      name: "country_code",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    { name: "port_code", type: "string", sort: true, infix: true },
    {
      name: "port_name",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "nz_hub",
      type: "bool",
      sort: true,
      infix: true,
      optional: true,
    },
    { name: "active", type: "bool", sort: true, infix: true },
    { name: "updated_at", type: "int64", sort: true, infix: true },
    {
      name: "updated_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
